<template>
  <div>
    <el-dialog
      :title="this.value.isCreate ? '新增配置' : '修改配置'"
      center
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="750px"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="200px"
        size="mini"
      >
        <el-form-item label="启用配置：">
          <el-switch v-model="form.isAvailable" active-color="#13ce66">
          </el-switch>
        </el-form-item>

        <el-form-item label="配置生效时间类型" prop="cycleType">
          <el-select v-model="form.cycleType" placeholder="请选择">
            <el-option
              v-for="item in cycleTypeSelector"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div v-if="form.cycleType != 0">
          <el-form-item label="配置生效开始时间" prop="cycleStart">
            <div v-if="form.cycleType == 1">
              <el-date-picker
                v-model="cycleForm.cycleStart1"
                type="datetime"
                :clearable="false"
                placeholder="选择时间"
                format="yyyy-MM-dd HH:mm"
                value-format="timestamp"
              >
              </el-date-picker>
            </div>
            <div v-else-if="form.cycleType == 2">
              <el-select
                style="width: 130px"
                v-model="cycleForm.cycleStart2"
                placeholder="从几点"
              >
                <el-option
                  v-for="item in 24"
                  :key="item"
                  :label="`${item - 1}点`"
                  :value="item - 1"
                >
                </el-option>
              </el-select>
              <el-select
                style="width: 120px; margin-left: 3px"
                v-model="cycleForm.cycleStart2_1"
                placeholder="几分"
              >
                <el-option
                  v-for="item in 60"
                  :key="item"
                  :label="`${item - 1}分`"
                  :value="item - 1"
                >
                </el-option>
              </el-select>
            </div>
            <div v-else-if="form.cycleType == 3">
              <el-select
                style="width: 130px"
                v-model="cycleForm.cycleStart3"
                placeholder="周几"
              >
                <el-option
                  v-for="item in weekDay"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-select
                style="width: 120px; margin-left: 3px"
                v-model="cycleForm.cycleStart3_1"
                placeholder="几点"
              >
                <el-option
                  v-for="item in 24"
                  :key="item"
                  :label="`${item - 1}点`"
                  :value="item - 1"
                >
                </el-option>
              </el-select>
              <el-select
                style="width: 120px; margin-left: 3px"
                v-model="cycleForm.cycleStart3_2"
                placeholder="几分"
              >
                <el-option
                  v-for="item in 60"
                  :key="item"
                  :label="`${item - 1}分`"
                  :value="item - 1"
                >
                </el-option>
              </el-select>
            </div>
            <div v-else>
              <el-input v-model="form.cycleStart"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="配置生效结束时间" prop="cycleEnd">
            <div v-if="form.cycleType == 1">
              <el-date-picker
                v-model="cycleForm.cycleEnd1"
                type="datetime"
                :clearable="false"
                placeholder="选择时间"
                format="yyyy-MM-dd HH:mm"
                value-format="timestamp"
              >
              </el-date-picker>
            </div>
            <div v-else-if="form.cycleType == 2">
              <el-select
                style="width: 130px"
                v-model="cycleForm.cycleEnd2"
                placeholder="到几点(可跨天)"
              >
                <el-option
                  v-for="hour in 24"
                  :key="hour"
                  :label="`${hour - 1}点`"
                  :value="hour - 1"
                >
                </el-option>
              </el-select>

              <el-select
                style="width: 120px; margin-left: 3px"
                v-model="cycleForm.cycleEnd2_1"
                placeholder="几分"
              >
                <el-option
                  v-for="item in 60"
                  :key="item"
                  :label="`${item - 1}分`"
                  :value="item - 1"
                >
                </el-option>
              </el-select>
            </div>
            <div v-else-if="form.cycleType == 3">
              <el-select
                style="width: 130px"
                v-model="cycleForm.cycleEnd3"
                placeholder="到周几(可跨周)"
              >
                <el-option
                  v-for="item of weekDay"
                  :key="item.value + $util.uuid()"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-select
                style="width: 120px; margin-left: 3px"
                v-model="cycleForm.cycleEnd3_1"
                placeholder="几点"
              >
                <el-option
                  v-for="item in 24"
                  :key="item"
                  :label="`${item - 1}点`"
                  :value="item - 1"
                >
                </el-option>
              </el-select>
              <el-select
                style="width: 120px; margin-left: 3px"
                v-model="cycleForm.cycleEnd3_2"
                placeholder="几分"
              >
                <el-option
                  v-for="item in 60"
                  :key="item"
                  :label="`${item - 1}分`"
                  :value="item - 1"
                >
                </el-option>
              </el-select>
            </div>
            <div v-else>
              <el-input v-model="form.cycleEnd"></el-input>
            </div>
          </el-form-item>
        </div>
        <el-form-item label="配置生效渠道">
          <channel-selector
            placeholder="请选择"
            enableFullChannels
            @ready="onChannelSelectorReady"
            @change="onChannelSelectorChange"
            ref="channelSelector"
          >
          </channel-selector>
        </el-form-item>
        <el-form-item label="配置生效最低版本" prop="minVersion">
          <el-input
            v-model="form.minVersion"
            placeholder="比如1.0.1"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="配置生效最高版本" prop="maxVersion">
          <el-input
            v-model="form.maxVersion"
            placeholder="比如1.0.1"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="Key" prop="key">
          <el-input
            v-model="form.key"
            placeholder="约定好的一个代表目标功能的标识，比如“ios支付”"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="自定义参数">
          <el-input
            v-model="form.param"
            placeholder="和客户端约定好格式的参数，如需多个参数可用约定好的分隔符串起来"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="得通过第几关" prop="minLevel">
          <el-input
            v-model="form.minLevel"
            placeholder="填10就代表第10关"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="满足所有条件后的开关状态" prop="status">
          <el-select
            v-model="form.status"
            placeholder="请选择"
            style="width: 80px"
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="form.remark"
            placeholder="多少写点儿什么吧..."
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submit()" style="margin-left: 30px">{{
          this.value.isCreate ? "确定" : "保存"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
import ChannelSelector from "@/components/ChannelSelector";

export default {
  data() {
    return {
      visible: true,
      form: {
        isAvailable: true,
        channelId: "",
        key: "",
        param: "",
        minLevel: "",
        minVersion: "",
        maxVersion: "",
        remark: "",
        status: "",
        cycleType: 0,
        cycleStart: "",
        cycleEnd: "",
      },
      cycleForm: {
        cycleStart1: new Date(),
        cycleEnd1: new Date(
          new Date().getTime() + 1000 * 3600 * 24 * 365 * 100
        ),
        cycleStart2: 0,
        cycleStart2_1: 0,
        cycleEnd2: 23,
        cycleEnd2_1: 59,
        cycleStart3: 1,
        cycleStart3_1: 0,
        cycleStart3_2: 0,
        cycleEnd3: 7,
        cycleEnd3_1: 23,
        cycleEnd3_2: 59,
      },
      rules: {
        channelId: [{ required: true, message: " ", trigger: "blur" }],
        key: [{ required: true, message: " ", trigger: "blur" }],
        status: [{ required: true, message: " ", trigger: "blur" }],
        minLevel: [{ required: true, message: " ", trigger: "blur" }],
        minVersion: [{ required: true, message: " ", trigger: "blur" }],
        maxVersion: [{ required: true, message: " ", trigger: "blur" }],
      },
      statusOptions: [
        {
          value: 0,
          label: "关",
        },
        {
          value: 1,
          label: "开",
        },
      ],
      cycleTypeSelector: [
        {
          value: 0,
          label: "永久",
        },
        {
          value: 1,
          label: "现实时间",
        },
        {
          value: 2,
          label: "24小时内",
        },
        {
          value: 3,
          label: "七天内",
        },
      ],
      weekDay: [
        {
          value: 1,
          label: "周一",
        },
        {
          value: 2,
          label: "周二",
        },
        {
          value: 3,
          label: "周三",
        },
        {
          value: 4,
          label: "周四",
        },
        {
          value: 5,
          label: "周五",
        },
        {
          value: 6,
          label: "周六",
        },
        {
          value: 7,
          label: "周日",
        },
      ],
    };
  },

  props: {
    value: Object,
  },

  components: {
    ChannelSelector,
  },

  created() {
    if (!this.value.isCreate) {
      this.form.channelId = this.value.oldData.channelId;
      this.form.key = this.value.oldData.key;
      this.form.param = this.value.oldData.param;
      this.form.minLevel = this.value.oldData.minLevel;
      this.form.minVersion = this.value.oldData.minVersion;
      this.form.maxVersion = this.value.oldData.maxVersion;
      this.form.remark = this.value.oldData.remark;
      this.form.status = this.value.oldData.status;
      this.form.cycleType = this.value.oldData.cycleType;
      this.form.isAvailable = this.value.oldData.isAvailable;

      if (this.form.cycleType == 1) {
        this.cycleForm.cycleStart1 = new Date(this.value.oldData.cycleStart);
        this.cycleForm.cycleEnd1 = new Date(this.value.oldData.cycleEnd);
      } else if (this.form.cycleType == 2) {
        this.cycleForm.cycleStart2 = parseInt(
          Number(this.value.oldData.cycleStart) / 60
        );
        this.cycleForm.cycleStart2_1 = parseInt(
          Number(this.value.oldData.cycleStart) % 60
        );
        this.cycleForm.cycleEnd2 = parseInt(
          Number(this.value.oldData.cycleEnd) / 60
        );
        this.cycleForm.cycleEnd2_1 = parseInt(
          Number(this.value.oldData.cycleEnd) % 60
        );
      } else if (this.form.cycleType == 3) {
        this.cycleForm.cycleStart3 =
          parseInt(Number(this.value.oldData.cycleStart) / (60 * 24)) + 1;

        let startDayMinutes = parseInt(
          Number(this.value.oldData.cycleStart) % (60 * 24)
        );
        this.cycleForm.cycleStart3_1 = parseInt(startDayMinutes / 60);
        this.cycleForm.cycleStart3_2 = parseInt(startDayMinutes % 60);

        this.cycleForm.cycleEnd3 =
          parseInt(Number(this.value.oldData.cycleEnd) / (60 * 24)) + 1;

        let endDayMinutes = parseInt(
          Number(this.value.oldData.cycleEnd) % (60 * 24)
        );
        this.cycleForm.cycleEnd3_1 = parseInt(endDayMinutes / 60);
        this.cycleForm.cycleEnd3_2 = parseInt(endDayMinutes % 60);
      }
    } else {
      this.form.status = 0; // 给一个默认状态
      this.form.isAvailable = true;
    }
  },

  methods: {
    async onChannelSelectorReady() {
      if (!this.value.isCreate) {
        this.$refs.channelSelector.channelId = this.form.channelId;
      }
    },

    async onChannelSelectorChange(newChannelId, oldChannelId) {
      this.form.channelId = newChannelId;
    },

    /**
     * 提交表单
     */
    submit() {
      if (this.form.channelId === "") {
        this.$alert("请选择渠道");
        return;
      }

      if (this.form.cycleType == 0) {
        this.form.cycleStart = "";
        this.form.cycleEnd = "";
      } else if (this.form.cycleType == 1) {
        let cycleStart1Date = new Date(Number(this.cycleForm.cycleStart1));
        let cycleEnd1Date = new Date(Number(this.cycleForm.cycleEnd1));
        let cycleStart1 = cycleStart1Date.setHours(
          cycleStart1Date.getHours(),
          cycleStart1Date.getMinutes(),
          0,
          0
        );
        let cycleEnd1 = cycleEnd1Date.setHours(
          cycleEnd1Date.getHours(),
          cycleEnd1Date.getMinutes(),
          0,
          0
        );
        if (cycleStart1 >= cycleEnd1) {
          this.$message.error("配置生效开始时间必须早于配置生效结束时间");
          return;
        }

        this.form.cycleStart = this.$util.ms2datetime(cycleStart1);
        this.form.cycleEnd = this.$util.ms2datetime(cycleEnd1);
      } else if (this.form.cycleType == 2) {
        let cycleStart2 = Number(this.cycleForm.cycleStart2);
        let cycleStart2_1 = Number(this.cycleForm.cycleStart2_1);
        let cycleEnd2 = Number(this.cycleForm.cycleEnd2);
        let cycleEnd2_1 = Number(this.cycleForm.cycleEnd2_1);
        this.form.cycleStart = String(cycleStart2 * 60 + cycleStart2_1);
        this.form.cycleEnd = String(cycleEnd2 * 60 + cycleEnd2_1);
      } else if (this.form.cycleType == 3) {
        let cycleStart3 = Number(this.cycleForm.cycleStart3);
        let cycleStart3_1 = Number(this.cycleForm.cycleStart3_1);
        let cycleStart3_2 = Number(this.cycleForm.cycleStart3_2);
        let cycleEnd3 = Number(this.cycleForm.cycleEnd3);
        let cycleEnd3_1 = Number(this.cycleForm.cycleEnd3_1);
        let cycleEnd3_2 = Number(this.cycleForm.cycleEnd3_2);

        this.form.cycleStart = String(
          (cycleStart3 - 1) * 24 * 60 + cycleStart3_1 * 60 + cycleStart3_2
        );
        this.form.cycleEnd = String(
          (cycleEnd3 - 1) * 24 * 60 + cycleEnd3_1 * 60 + cycleEnd3_2
        );
      }

      // return;
      if (this.value.isCreate) {
        this.add();
      } else {
        this.update();
      }
    },

    /**
     * 新增
     */
    add() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/addFunctionSwitch`,
            {
              switch: {
                isAvailable: this.form.isAvailable,
                channelId: this.form.channelId,
                key: this.form.key,
                param: this.form.param,
                minLevel: this.form.minLevel,
                minVersion: this.form.minVersion,
                maxVersion: this.form.maxVersion,
                remark: this.form.remark,
                status: this.form.status,
                cycleType: this.form.cycleType,
                cycleStart: this.form.cycleStart,
                cycleEnd: this.form.cycleEnd,
              },
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "添加成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      });
    },

    /**
     * 修改
     */
    update() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/updateFunctionSwitch`,
            {
              switch: {
                isAvailable: this.form.isAvailable,
                channelId: this.form.channelId,
                id: this.value.oldData.id,
                key: this.form.key,
                param: this.form.param,
                minLevel: this.form.minLevel,
                minVersion: this.form.minVersion,
                maxVersion: this.form.maxVersion,
                remark: this.form.remark,
                status: this.form.status,
                cycleType: this.form.cycleType,
                cycleStart: this.form.cycleStart,
                cycleEnd: this.form.cycleEnd,
              },
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      });
    },

    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>
